/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：561
 */

"use strict"

function r(e, t) {
  return !!e && e.contains(t)
}
export { r as a }
export default r
